import { DashLanguages } from "dash-common";
import { i18next } from "dash-ui";

// Must be dash-ui's instance: an app-side `import i18next from "i18next"`
// resolves to a separate, uninitialised copy.
export const applyPortalLanguage = (language: DashLanguages) => {
  if (i18next.language !== language) void i18next.changeLanguage(language);
  document.documentElement.lang = language;
};
